import { useEffect } from 'react';
import { gspx } from '@rsos/gainsight';
import useAppNameToPage from './useAppNametoPage';

const trackRefreshBrowser = app => {
  gspx.trackCustomEvent('Auth', {
    Category: 'Auth',
    'Launched date': new Date(),
    name: `user refreshes the browser in ${app} page`,
  });
};

const useBrowserRefresh = () => {
  const readableName = useAppNameToPage();
  useEffect(() => {
    try {
      const entries = performance.getEntriesByType('navigation');
      entries.forEach(entry => {
        if (entry.type === 'reload') {
          if (readableName) {
            trackRefreshBrowser(readableName);
          }
        }
      });
    } catch {
      // Silently fail
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useBrowserRefresh;
